// extracted by mini-css-extract-plugin
module.exports = {"btn":"Edit_btn__20Vh1"};